import React from 'react';

export default function ProgressBar({ percentage, passName }) {
  return (
    <div className="mb-8 p-6 border-2 border-black bg-white shadow-brutal-sm">
      <div className="flex justify-between items-end mb-3">
        <div>
          <h2 className="font-bold text-lg uppercase tracking-tight">{passName}</h2>
          <p style={{
      color: 'rgb(107, 114, 128)',
      fontSize: '14px',
      fontWeight: '500'
    }} className="text-xs text-gray-500 uppercase tracking-widest mt-1">Completion Status</p>
        </div>
        <span className="font-bold text-3xl leading-none">{Math.round(percentage)}%</span>
      </div>
      <div className="h-2 w-full bg-offwhite border border-black relative overflow-hidden">
        <div 
          className="absolute top-0 left-0 h-full bg-orange transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}